import clsx from 'clsx';
import { SchemaOrgItemProp } from '@headless-workspace/config';
import { GlowTextBody, GlowTitle, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import chanelStyles from './chanel.module.css';

type ProductTitleWithMetaProps = PropsWithFontFamily & {
    name?: {
        full: string;
        partOne: string;
        partTwo?: string;
    };
    isChanelBrand?: boolean;
};

export const ProductTitleWithMeta: Component<ProductTitleWithMetaProps> = ({
    name,
    fontFamily,
    isChanelBrand = false,
}) => {
    if (!name) {
        return null;
    }

    return (
        <>
            <meta itemProp={SchemaOrgItemProp.Name} content={name.full} />
            <GlowTitle
                className={clsx(isChanelBrand && chanelStyles.chanelProductNameText)}
                text={name.partOne}
                fontSize={'title3'}
                TagName={'h1'}
                fontFamily={fontFamily}
            />
            {name.partTwo && (
                <GlowTextBody
                    className={clsx(isChanelBrand && chanelStyles.chanelProductNameDetailText)}
                    text={name.partTwo}
                    fontFamily={fontFamily}
                />
            )}
        </>
    );
};
